import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'archived'
})
export class ArchivedPipe implements PipeTransform {
  constructor (
    private translateService: TranslateService
  ) {}

  transform ( isArchived : boolean, options : any = { html: true } ) : string {
    return isArchived
    ? options.html
      ? `<span class="badge bg-danger">
          ${ this.translateService.instant('GENERAL_SPACE.SWITCH.ARCHIVED') }
        </span>`
      : this.translateService.instant('GENERAL_SPACE.SWITCH.ARCHIVED')
    : '';
  }
}
